import { Component, OnInit } from '@angular/core';
import { EditorService } from '../services/editor.service';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { AboutUsInputComponent } from './about-us-input/about-us-input.component';

@Component({
  selector: 'ngx-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit{
  
  inputComponent = new DynamicInputComponent(AboutUsInputComponent);
  menuGroups:any;
  title = "Editing About Us Route";
  menuTag = "editAboutUsPageRouteMenu";
  menuGroup:MenuGroup = {
    title:"Editing About Us Page Route",
    menuTag:"editAboutUsPageRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            /* children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ] */
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          },
          {
            title:'Blog List',
          },
          {
            title:'Product List',
          },
          {
            title:'Feature List',
          },
          {
            title:'Testimonials'
          },
          {
            title:'Rich Text'
          },
          {
            title:'News Letter Sign Up'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  previousMenu:NbMenuItem[] = [];
  menuItems:NbMenuItem[] = [
    {
      title:'Add Section',
    },
    {
      title:'Remove Section'
    },
    {
      title:'Order Sections'
    }
  ]
  
  constructor(private editorService:EditorService,
    private menuService:NbMenuService){}
  
  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.setMenu(selectedItem);
      }
    })
  }

  setMenu(selectedItem:NbMenuItem){
    if(selectedItem.title == "Back"){
      this.menuItems = this.previousMenu;
    }else{
      this.menuGroup.menuItems.forEach(menuItem => {
        if(menuItem.title == selectedItem.title && menuItem.children != null){
          this.previousMenu = this.menuItems;
          console.log(menuItem.title);
          let backLinkLNbMenuItem = {title:"Back",icon:"arrow-back-outline"};
          let headerItem:NbMenuItem = {title:menuItem.title,group:true}
          this.menuItems = [backLinkLNbMenuItem,headerItem].concat(menuItem.children);
        }
      })
    }
    
  }
}
